<script>
    import { mapGetters } from 'vuex'

    import Goal from '@/components/Goal'

    import { format } from 'date-fns'
    import EventBus from '../event-bus'

    import store from '@/store/index'

    export default {
        data () {
            return {
                format,
                visible : false,
                selected: null
            }
        },
        components: {
            Goal
        },
        computed: {
            desc() {
                return this.goals.sort((a,b) => {
                    return parseInt(b.CreateDate) - parseInt(a.CreateDate)
                })
            },
            ...mapGetters({
                goals: 'teacher/getGoals',
                role: 'getUserRole'
            })
        },
        methods: {
            createGoal() {
                this.visible = true
                this.selected = null
            },
            openGoal(goal) {
                this.selected = goal
                this.visible = true
                this.$ga.event({
                    eventCategory: 'Open existing goal',
                    eventAction: store.getters['getDBN']
                        ? store.getters['getDBN']
                        : store.getters['admin/getSelectedSchool']['dbn'],
                    eventLabel: this.role,
                })
            },
            formatDate(date) {
                return format(date, 'MMM. DD')
            },
            createdBy(id, note) {
                return id === note.CreatedForUserID ? `me` : `who is this person?`
            }
        },
        mounted() {
            EventBus.$on('disableVisibility', () => {
                this.visible = false
                this.selected = null
            })
        }
    }
</script>

<template>
    <div class="goals">
        <div class="goals-heading">
            <span>Goals</span>
        </div>
        <div class="goals-content">
            <div class="goals-content-info">
                <div v-if="goals.length === 0"  class="goals-content__empty">
                    <p>Set a new goal. <span @click="createGoal">{{visible === true ? '-' : '+'}}</span></p>
                </div>
                <div v-else class="goals-list">
                    <div class="goals-list-tabs">
                        <ul>
                            <li><button @click="createGoal">create new</button></li>
                        </ul>
                    </div>
                    <ul class="goals-list-items">
                        <li class="goal-list-item" @click="openGoal(goal)" v-for="goal in desc" :key="goal.GoalID">
                            <div class="goal-list-item-meta">
                                <h3>{{goal.GoalTitle}}</h3>
                                <span>{{formatDate(goal.CreateDate)}}</span>
                            </div>
                            <div class="goal-list-item-content">
                                <p>{{goal.GoalDetail}}</p>
                                <span>{{!goal.IsPublished ? 'locked': 'shared'}}</span>
                            </div>
                            <span>{{visible === true && goal.GoalID === (selected && selected.GoalID) ? '-' : '+'}}</span>
                        </li>
                    </ul>
                </div>
                <Goal :role="role" :goal="selected ? selected: null" :visible="visible" />
            </div>
        </div>
        <div class="goals-action">
            <button @click="createGoal">
                <img src="../assets/images/pencil-icon.svg" alt="pencil icon" />
            </button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .goals {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        .goals-heading {
            display: none;
            box-sizing: border-box;
            margin: 1em 0;
            padding-bottom: 1em;
            border-bottom: 1px solid #979797;
            color: #613f75;
            font-family: 'museo_slab', sans-serif;
            * {
                display: inline-block;
                margin-right: 5px;
            }
            h1 {
                font-size: 36px;
                text-transform: uppercase;
                margin: 0 5px 0 0;
                @media screen and (min-width: 1070px) {
                    font-size: 48px;
                }
            }
            span {
                font-size: 30px;
                @media screen and (min-width: 1070px) {
                    font-size: 36px;
                }
            }
            @media screen and (min-width: 767px) {
                display: block;
            }
        }
        .goals-content {
            width: 100%;
            display: flex;
            flex-direction: column;
            @media screen and (min-width: 1070px) {
                flex-direction: row;
            }
            .goals-content-info {
                width: 100%;
                @media screen and (min-width: 1070px) {
                    max-width: 50%;
                }
            }
            .goals-content-tracker {
                @media screen and (min-width: 767px) {
                    display: block;
                    min-height: 400px;
                }
                @media screen and (min-width: 1070px) {
                    min-width: 50%;
                }
                h2 {
                    margin: 0;
                    color: #613f75;
                    @media screen and (min-width: 1070px) {
                        font-size: 30px;
                    }
                }
            }
        }
        .goals-content__empty {
            margin-bottom: 2em;
            p span {
                display: none;
                @media screen and (min-width: 1070px) {
                    display: inline;
                    position: absolute;
                    bottom: 5px;
                    right: 5px;
                    color: #000000;
                    cursor: pointer;
                }
            }
        }
        .goals-content__empty p {
            box-sizing: border-box;
            position: relative;
            margin: 0;
            align-self: center;
            font-family: 'museo_sans';
            font-size: 18px;
            padding: 2em 1em;
            width: 300px;
            height: 300px;
            line-height: 22px;
            @media screen and (min-width: 1070px) {
               background-color: #ffffff;
               border: 7px solid #cfffe5;
               font-size: 30px;
               line-height: 36px;
               text-align: center;
            }
        }
        h1 {
            margin: 0;
            font-size: 18px;
            text-align: center;
        }
        .goals-content {
            display: flex;
            flex: 1;
        }
        .goals-list {
            width: 100%;
            .goals-list-tabs {
                display: none;
                @media screen and (min-width: 1070px) {
                    display: block;
                }
                ul {
                    list-style-type: none;
                    display: flex;
                    padding: 0;
                    li {
                        button {
                            padding: 5px 10px;
                            background: transparent;
                            border: 1px solid #ae94db;
                            color: #ae94db;
                            text-transform: uppercase;
                            font-size: 14px;
                            cursor: pointer;
                        }
                    }
                }
            }
            .goals-list-items {
                padding: 0;
                list-style-type: none;
                @media screen and (min-width: 1070px) {
                    display: flex;
                    flex-wrap: nowrap;
                    overflow-x: auto;        
                }
                li {
                    font-family: 'museo_sans';
                    padding: 10px;
                    margin-bottom: 1em;
                    background-color: rgba(207, 255, 229, 0.62);
                    color: #000000;
                    display: flex;
                    flex-direction: column;
                    cursor: pointer;
                    @media screen and (min-width: 1070px) {
                        height: 300px;
                        min-width: 300px;
                    }
                    h3 {
                        margin: 0;
                        font-size: 14px
                    }
                    div {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        &:first-child {
                            margin-bottom: 1em;
                        }
                    }
                    div span {
                        font-size: 14px;
                    }
                    div p {
                        font-size: 12px;
                        color: #979797;
                    }
                    .goal-list-item-meta {
                        @media screen and (min-width: 1070px) {
                            display: flex;
                            h3 {
                                width: 100%;
                                margin: 0;
                                font-size: 30px;
                                line-height: 36px;
                                text-align: center;
                                color: #000000;
                            }
                            span {
                                display: none;
                            }

                        }
                        h3 {
                            font-family: 'museo_sans';
                        }
                    }
                    .goal-list-item-content {
                        @media screen and (min-width: 1070px) {
                            display: none;      
                        }
                        p {
                            font-family: 'museo_sans';
                        }
                        span {
                            @media screen and (min-width: 1070px) {
                                display: none;
                            }
                        } 
                    }
                }
            }
        }
        .goal-list-item {
            position: relative;
            span { 
                display: none;
                font-size: 28px;
                @media screen and (min-width: 1070px) {
                    display: block;
                    position: absolute;
                    bottom: 10px;
                    right: 10px;
                }
            }
            @media screen and (min-width: 1070px) {
                display: flex;
                justify-content: center;
                margin-right: 1em;         
            }
            
        }
        
        .goals-action {
            @media screen and (min-width: 1070px) {
                display: none;
            }
            position: fixed;
            display: flex;
            justify-content: center;
            bottom: 0;
            right: 0;
            background-color: #e7dbee;
            width: 70px;
            height: 70px;
            button {
                background-color: transparent;
                border: none;
            }
        }
    }
    .visible {
        display: flex;
        flex-direction: column;
    }
</style>
